<script lang="ts" setup>
import { IconVueFeather, type IconNameType } from '@c4-links/vue3-links-components';
import { MenuItem } from '@headlessui/vue';
import type { PropType } from 'vue';

defineProps({
  icon: {
    type: String as PropType<IconNameType>,
    required: false,
    default: undefined
  },
  disabled: { type: Boolean, required: false, default: false },
  testId: { type: String, required: false, default: undefined }
});

defineEmits<{
  click: [];
}>();
</script>

<template>
  <MenuItem v-slot="{ active }" class="px-0">
    <button
      :class="[
        'block px-3 py-1 space-x-2 text-left text-sm leading-6 whitespace-nowrap text-gray-900 w-full break',
        active ? 'bg-gray-50' : 'cursor-pointer',
        disabled && 'text-opacity-40 pointer-events-none'
      ]"
      :data-testid="testId"
      :disabled="disabled"
      @click="$emit('click')"
    >
      <IconVueFeather v-if="icon" :type="icon" :size="12" />
      <slot :active="active" />
    </button>
  </MenuItem>
</template>
